'use client';
import Header from'../components/common/Header';
import Footer from'../components/common/Footer';
import HeroSection from'./HeroSection';
import IntroductionSection from'./IntroductionSection';
import JulyPredictionSection from'./JulyPredictionSection';
import UnderlayScrollerSection from'./UnderlayScrollerSection';
import NewFeatureSection from'./NewFeatureSection';
import MadameLenormandSection from'./MadameLenormandSection';
import TarotSymbolsSection from'./TarotSymbolsSection';
import SocialMediaSection from'./SocialMediaSection';
import TagsSection from './TagsSection';
import { useTranslations } from '../utils/translations';

export default function HomePage() {
  const { isLoading } = useTranslations();
  
  return (
    <div className="min-h-screen bg-[var(--bg-main)] text-[var(--text-primary)]">
      <Header />
      
      <main className="w-full pt-[40px] sm:pt-[60px] md:pt-[82px] overflow-x-hidden">
        {!isLoading && (
          <>
            <HeroSection />
            <IntroductionSection />
            <JulyPredictionSection />
            <UnderlayScrollerSection />
            <NewFeatureSection />
            <MadameLenormandSection />
            <TarotSymbolsSection className="py-8 md:py-12" />
            <SocialMediaSection className="py-6 md:py-8" />
            <TagsSection className="py-6 md:py-8" />
          </>
        )}
      </main>
      
      <Footer />
    </div>
  )
}